import { combineTokens } from '@utils/css';

combineTokens("--drawer", {
  amountOfColumns: 5,
  amountOfRows: 1
});
const drawer = "_35sddemnwh";
const label = "_35sl1qz175f";

export { drawer, label };
import "./molecule.drawer.style.linaria.module.css";
//# sourceMappingURL=molecule.drawer.style.js.map
